// Theming-related SWR fetches. Conditional keys gate on survey resolving cleanly and IDs being present.

import useSWR from "swr";

import { fetcherSimple } from "utils/api";

export function useThemingData({
    surveyId,
    survey,
    surveyError,
    isBlocked,
    themesPage,
    answerTheming,
    themeEdit,
}) {
    const {
        data: themesData,
        error: themesDataError,
        mutate: themesDataMutate,
    } = useSWR(
        () =>
            survey && !surveyError && !isBlocked
                ? [`/v2/survey/${surveyId}/theme?page=${themesPage}`, "GET"]
                : null,
        ([path, method]) => fetcherSimple(path, method),
    );

    const {
        data: answerThemes,
        error: answerThemesError,
        isValidating: answerThemesValidating,
        mutate: answerThemesMutate,
    } = useSWR(
        () =>
            answerTheming
                ? [`/v2/response/answer/${answerTheming}/themes`, "GET"]
                : null,
        ([path, method]) => fetcherSimple(path, method),
    );

    const {
        data: themeAnswers,
        error: themeAnswersError,
        isValidating: themeAnswersValidating,
        mutate: themeAnswersMutate,
    } = useSWR(
        () =>
            themeEdit
                ? [`/v2/survey/${surveyId}/theme/${themeEdit.id}`, "GET"]
                : null,
        ([path, method]) => fetcherSimple(path, method),
    );

    return {
        themesData,
        themesDataError,
        themesDataMutate,
        answerThemes,
        answerThemesError,
        answerThemesValidating,
        answerThemesMutate,
        themeAnswers,
        themeAnswersError,
        themeAnswersValidating,
        themeAnswersMutate,
    };
}
